"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("intersection-observer");
var ResponsiveMenuItems = (function () {
    function ResponsiveMenuItems() {
        this.rootMargin = '0px -71px 0px 0px';
        this.ratio = 0.9;
        this.maxOffsetLeft = 0;
        this.io = null;
        this.header = document.querySelector('header.desktop');
        this.menuItems = this.header.querySelectorAll('nav.main-menu > span.menu-item');
        this.menuItemCount = this.menuItems.length;
        this.mainMenu = this.header.querySelector('nav.main-menu');
        this.moreMenu = this.mainMenu.querySelector('nav.more');
        this.createIntersectionObserver();
        for (var i = 0; i < this.menuItemCount; ++i) {
            this.io.observe(this.menuItems.item(i));
        }
    }
    ResponsiveMenuItems.getInstance = function () {
        if (!this.instance) {
            this.instance = new ResponsiveMenuItems();
        }
        return this.instance;
    };
    ResponsiveMenuItems.prototype.createIntersectionObserver = function () {
        this.io = new IntersectionObserver(this.handleIntersectionObserverEvent.bind(this), {
            root: this.header.querySelector('nav.main-menu'),
            rootMargin: this.rootMargin,
            threshold: [0, 0.1, 0.5, 0.6, 0.7, 0.8, 0.9, 0.999, 1]
        });
        return this.io;
    };
    ResponsiveMenuItems.prototype.handleIntersectionObserverEvent = function (entries, observer) {
        this.maxOffsetLeft = 0;
        entries.forEach(this.checkVisibility.bind(this));
        this.insertMoreMenuBeforeHidden();
    };
    ResponsiveMenuItems.prototype.checkVisibility = function (entry, idx) {
        if (entry.intersectionRatio < this.ratio) {
            entry.target.classList.add('hide');
            if (this.hasActiveMenuItems()) {
                this.moreMenu.classList.add('active');
            }
            this.moreMenu.querySelector(".menu-item[data-href='" + entry.target.getAttribute('data-href') + "']").classList.add('show');
        }
        else {
            this.maxOffsetLeft = Math.max(entry.boundingClientRect.right, this.maxOffsetLeft);
            entry.target.classList.remove('hide');
            this.moreMenu.querySelector(".menu-item[data-href='" + entry.target.getAttribute('data-href') + "']").classList.remove('show');
        }
    };
    ResponsiveMenuItems.prototype.hasActiveMenuItems = function () {
        return this.moreMenu.querySelectorAll('.show.active').length > 0;
    };
    ResponsiveMenuItems.prototype.insertMoreMenuBeforeHidden = function () {
        this.mainMenu.insertBefore(this.moreMenu, this.header.querySelector('nav.main-menu > .hide'));
    };
    return ResponsiveMenuItems;
}());
exports.default = ResponsiveMenuItems;
